<!-- 性別入力コンポーネント -->
<template>
    <dd :class="validate.$error | klass">
        <template v-if="validate.$error">
            <span class="errNote">性別を選択してください。</span>
        </template>
        <label class="select">
            <select v-model="validate.$model"
                    @change="setUserInfoPatch"
                    name="sex_kbn">
                <option value="0" selected>無回答</option>
                <option value="1">男性</option>
                <option value="2">女性</option>
            </select>
        </label>
    </dd>
</template>

<script>
import { mixinUserInfoFieldComponent } from '../../mixin/utility'

export default {
    name: "UserInfoSexField",
    mixins: [mixinUserInfoFieldComponent],
    props: {
        validate: {
            type: Object,
            required: true
        }
    },
    methods: {
        setUserInfoPatch: function(ev){
            const value = ev.target.value;
            this.$emit('set-user-info-patch', 'sex_kbn', value);
        }
    }
}
</script>
